import { Drawer, State } from '@seiue/ui'
import { useEffect, useState } from 'react'

import {
  SchoolPlugin,
  SchoolPluginTag,
  pluginApi,
} from 'packages/sdks-next/growp'
import { EntryComponentsWrapper } from 'packages/theme'

import { DragSchoolPlugin, DragTag } from '../utils/type'
import { TagContext, allTagName } from '../utils/util'

import { TagDrawerContent } from './components/TagDrawerContent'
import { TagDrawerDetail } from './components/TagDrawerDetail'
import { TagDrawerFooter } from './components/TagDrawerFooter'
import { TagDrawerHeader } from './components/TagDrawerHeader'

/**
 * 分类抽屉
 *
 * @param param - 参数
 * @param param.visible - 是否可见
 * @param param.setVisible - 设置是否可见
 * @returns 组件
 */
export const TagDrawer: React.FC<{
  visible: boolean
  setVisible: (visible: boolean) => void
}> = ({ visible, setVisible }) => {
  const { data: allSchoolPlugins, loading: loading } =
    pluginApi.useQuerySchoolPlugins({
      paginated: 0,
    })

  const { data: allSchoolPluginTags, loading: loadingTag } =
    pluginApi.useQuerySchoolPluginTags()

  const [current, setCurrent] = useState<number>(0)
  const [showTag, setShowTag] = useState<SchoolPluginTag | undefined>(undefined)

  const [tags, setTags] = useState<SchoolPluginTag[]>(allSchoolPluginTags || [])
  const [schoolPlugins, setSchoolPlugins] = useState<SchoolPlugin[]>(
    allSchoolPlugins || []
  )

  const initDragTags = tags
    .filter((e) => e.isVirtual !== true)
    .sort((a, b) => (a.weight || 0) - (b.weight || 0))

  const [dragTags, setDragTags] = useState<DragTag[]>(initDragTags)
  const [dragSchoolPlugins, setDragSchoolPlugins] = useState<
    DragSchoolPlugin[]
  >([])

  useEffect(() => {
    const newTags = allSchoolPluginTags || []
    setTags(newTags)
    setSchoolPlugins(allSchoolPlugins || [])

    const newDragTags = newTags
      .filter((e) => e.isVirtual !== true)
      .sort((a, b) => (a.weight || 0) - (b.weight || 0))

    setDragTags(newDragTags)
  }, [allSchoolPlugins, allSchoolPluginTags])

  useEffect(() => {
    if (showTag === undefined) {
      setDragSchoolPlugins([])
      return
    }

    const isOtherTag = showTag?.name !== allTagName
    const showTagSchoolPlugins = !isOtherTag
      ? schoolPlugins.sort((a, b) => (a.weight || 0) - (b.weight || 0))
      : schoolPlugins
          .filter((e) => e.tagId === showTag?.id)
          .sort((a, b) => (a.groupWeight || 0) - (b.groupWeight || 0))

    setDragSchoolPlugins(showTagSchoolPlugins)
  }, [showTag])

  return (
    <TagContext.Provider
      value={{
        tags,
        setTags,
        current,
        setCurrent,
        showTag,
        setShowTag,
        dragTags,
        setDragTags,
        setVisible,
        schoolPlugins,
        dragSchoolPlugins,
        setDragSchoolPlugins,
      }}
    >
      <EntryComponentsWrapper>
        <Drawer
          title={<TagDrawerHeader />}
          headerStyle={{ padding: '20px 16px' }}
          bodyStyle={{ padding: 0 }}
          footerStyle={{ padding: 0 }}
          width={400}
          placement="right"
          onClose={() => {
            setVisible(false)
          }}
          visible={visible}
          destroyOnClose={true}
          footer={<TagDrawerFooter />}
        >
          {loading || loadingTag ? (
            <State.Loading />
          ) : current === 0 ? (
            <TagDrawerContent />
          ) : (
            <TagDrawerDetail />
          )}
        </Drawer>
      </EntryComponentsWrapper>
    </TagContext.Provider>
  )
}
